import React from "react"
import type {Limits, LimitOverrideType} from "../../../../resources/account"
import {CardLimitsSection} from "./CardLimitsSection"
import {AchLimitsSection} from "./AchLimitsSection"
import {CheckDepositLimitsSection} from "./CheckDepositLimitsSection"
import {CheckPaymentLimitsSection} from "./CheckPaymentLimitsSection"
import {WireLimitsSection} from "./WireLimitsSection"

export function AllLimitsSections({
	limits,
	onEditLimit,
}: {
	limits: Limits["attributes"]
	onEditLimit?: (limitType: LimitOverrideType) => void
}) {
	return (
		<>
			{limits.card && (
				<CardLimitsSection
					limits={limits.card.limits}
					total={limits.card.totalsDaily}
					override={limits.card.override}
				/>
			)}

			{limits.ach && (
				<AchLimitsSection
					limits={limits.ach.limits}
					total={{
						totalsDaily: {...limits.ach.totalsDaily},
						totalsMonthly: {...limits.ach.totalsMonthly},
					}}
					onEditLimit={onEditLimit}
					override={limits.ach.override}
				/>
			)}

			{limits.checkDeposit && (
				<CheckDepositLimitsSection
					limits={limits.checkDeposit.limits}
					total={{
						totalsDaily: limits.checkDeposit.totalsDaily,
						totalsMonthly: limits.checkDeposit.totalsMonthly,
					}}
					onEditLimit={onEditLimit}
					override={limits.checkDeposit.override}
				/>
			)}

			{limits.checkPayment && (
				<CheckPaymentLimitsSection
					limits={limits.checkPayment.limits}
					total={{
						totalsDaily: {...limits.checkPayment.totalsDaily},
						totalsMonthly: {...limits.checkPayment.totalsMonthly},
					}}
					onEditLimit={onEditLimit}
					override={limits.checkPayment.override}
				/>
			)}

			{limits.wire && (
				<WireLimitsSection
					limits={limits.wire.limits}
					total={{
						totalsDaily: {...limits.wire.totalsDaily},
						totalsMonthly: {...limits.wire.totalsMonthly},
					}}
					onEditLimit={onEditLimit}
					override={limits.wire.override}
				/>
			)}
		</>
	)
}
